import { makeStyles, Theme, createStyles } from "@material-ui/core/styles"

export const HeaderStyles = makeStyles((theme: Theme) => 

createStyles({
	headContainer: {
		position: "fixed",
		top: 0,
		left: 0,
		width: "100%",
		background: theme.palette.common.white,
		zIndex: 9,
		height:'80px',
	},

	headContainerinr: {
		display: "flex",
		padding: "0 16px",
		justifyContent: "space-between",
		alignItems:"center",
		fontFamily: theme.typography.fontFamily,
	},
	driverLogo: {
		"& .extcustomIcon": {
			width: "100%",
			maxWidth: 165,
			height: 68,
		}
	},
	headDivider: {
	},
	backIconBlock:{width:'33%',display:'flex',justifyContent:'flex-start'},
	logoBlock:{width:'33%'},
	phoneIconBlock:{width:'33%',display:'flex',justifyContent:'flex-end'},
	avatharCls: {
		width: 40,
		margin: "0 auto"
	},
	profilesection: {

	},
	profileavatar: {
		textAlign: "center",
		"& .extcustomIcon": {
			height: 30,
		}
	},
	profilename: {
		marginTop: 4,
		fontSize: 12,
		textAlign: "center",
		textTransform: "uppercase",
	},
	help: {
		cursor: "pointer",
		width: 40,
	},
	linearProgressMain: {
		backgroundColor: "#dddddd !important",
	},
	linearProgressPrimary: {
		backgroundColor: "#518ECB !important",
	},
	linearProgressDeterminate: {
		height: "6px !important",
	},
	linearProgressbar1Determinate: {
		borderRadius: 8
	},
	phoneBtn:{
		padding:`0 !important`,
		color:"#075280 !important" ,
		minWidth:'0px !important',
		display:'block',
		'@media (min-width: 600px)': {
			display:'none'
		}

	},
	phoneText:{
		padding:`0 !important`,
		minWidth:'0px',
		display:'none',
		"&:hover":{
			background:'transparent',
			pointer:'cursor'
		},
		'@media (min-width: 600px)': {
			display:'block'
		  }
		

	}

	

}));